import React, { useContext } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { formatHandlingUnits, isNullOrUndefined } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { RingilH2, RowWithSpaceBetween } from '@components/styles.tsx';
import ExpeditionDetailOptions from '@components/obsolete/ExpeditionDetailOptions/ExpeditionDetailOptions.tsx';
import { EntityTypeEnum, PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import LabelsTag from '@components/framework/tags/LabelsTag.tsx';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';

interface ComponentProps {
  applicationId?: string;
  distance?: number;
  expeditionType?: string | null;
  expeditionState: string;
  isExpeditionCanceled: boolean;
  expeditionToId: string;
  expeditionFromId: string;
  isManualExpedition: boolean;
  handlingUnitCount: number;
  expeditionId: string;
}

const ExpeditionDetailHeader: React.FC<ComponentProps> = ({
  applicationId,
  distance,
  expeditionType,
  expeditionState,
  isExpeditionCanceled,
  expeditionToId,
  expeditionFromId,
  isManualExpedition,
  handlingUnitCount,
  expeditionId,
}) => {
  const { t }: { t: any } = useTranslation('common');
  const { tr } = useTranslationLgs();
  const { hasPermission } = useContext(AuthenticatedUserContext);
  const className = '';

  const isCanceled = isExpeditionCanceled;
  const isSwitchedToManual = isManualExpedition && !isNullOrUndefined(expeditionToId);
  const isManual = isManualExpedition && isNullOrUndefined(expeditionToId);
  const isAutomatic = !isManualExpedition && !isExpeditionCanceled;
  const editHeaderPermission = hasPermission([PermissionTypesEnum.PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW]);

  return (
    <div className="p-grid">
      <div className="p-col-12 p-md-6">
        <RowWithSpaceBetween>
          <RingilH2>
            {t('labelExpedition')} <span>{applicationId}</span>
          </RingilH2>
        </RowWithSpaceBetween>

        <div className="p-d-flex p-ai-center">
          <p className="p-mb-0 p-mt-0 p-mr-5" data-testid="expeditionInfo-status">
            <>
              {isManual || (isSwitchedToManual && <span className={'text-red'}>{tr(`ExpeditionDetailHeader.switchedToManualMode`, 'Přepnuto na manuální režim ')}</span>)}

              {isCanceled && <div className={className}>{t('CANCELED', 'CANCELED')}</div>}
              {isAutomatic && <span className={className}>{t(expeditionState, expeditionState)}</span>}
            </>
          </p>
        </div>
      </div>

      <div className="p-col-12 p-md-6 p-d-flex p-jc-between p-jc-md-end">
        <ExpeditionDetailOptions value={`${distance || ' - '} km`} description={t('labelTotalDistance')} dataTestId="expeditionInfo-distance" />
        <ExpeditionDetailOptions
          value={expeditionType ? t(`expeditionTypeShort${expeditionType}`) : tr('global.expeditionTypeNotSpecified', 'Neuvedeno')}
          description={expeditionType ? t(`expeditionTypeLong${expeditionType}`) : ''}
          img="/images/local_shipping.png"
          dataTestId="expeditionInfo-transportationType"
        />
        <ExpeditionDetailOptions
          value={formatHandlingUnits(handlingUnitCount, tr)}
          description={tr(`CarrierExpeditionDetailHeader.totalHandlingUnits`, `Total handling units`)}
          dataTestId="expeditionInfo-handlingUnits"
        />
      </div>

      <div style={{ marginLeft: '16px' }}>
        <LabelsTag objectId={expeditionId} objectType={EntityTypeEnum.EXPEDITION}
                   resolveLabelsForType={EntityTypeEnum.EXPEDITION} disabled={!editHeaderPermission} dataTestId="expeditionInfo-label" />
      </div>
    </div>
  );
};

export default ExpeditionDetailHeader;
